import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

export const lightGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#F5BE8D',
    id: 'orange-1',
    position: [0, 0],
    opacity: 0.4,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#FBCE97',
    id: 'orange-2',
    position: [99, 0],
    opacity: 0.5,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#FDC382',
    id: 'orange-3',
    position: [10, 90],
    opacity: 0.5,
    size: 50,
  },
  {
    shape: 'circle',
    hex: '#F5BE8D',
    id: 'orange-4',
    position: [99, 99],
    opacity: 0.5,
    size: 40,
  },
];

export const grayGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#3C5B62',
    id: 'slate-1',
    position: [0, 0],
    opacity: 0.5,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#3C5B62',
    id: 'slate-2',
    position: [99, 0],
    opacity: 0.5,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#3C5B62',
    id: 'slate-3',
    position: [10, 90],
    opacity: 0.5,
    size: 50,
  },
  {
    shape: 'circle',
    hex: '#3C5B62',
    id: 'slate-4',
    position: [99, 99],
    opacity: 0.5,
    size: 40,
  },
];

export const darkGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#7B8792',
    id: 'blue-1',
    position: [0, 0],
    opacity: 0.5,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#7B8792',
    id: 'blue-2',
    position: [99, 0],
    opacity: 0.5,
    size: 30,
  },
  {
    shape: 'circle',
    hex: '#7B8792',
    id: 'blue-3',
    position: [10, 90],
    opacity: 0.5,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#7B8792',
    id: 'blue-4',
    position: [99, 99],
    opacity: 0.5,
    size: 40,
  },
];
